import React from 'react';
import {Button} from 'antd';
import CapabilityFlow from '../../components/site/CapabilityFlow';
import FeatureGrid from '../../components/site/FeatureGrid';
import HeroSection from '../../components/site/HeroSection';
import SectionTitle from '../../components/site/SectionTitle';
import SplitShowcase from '../../components/site/SplitShowcase';
import {useWaitlist} from '../../components/site/WaitlistModal';
import {useSiteContent} from './siteContent';
import styles from './SitePages.module.css';

const SolutionsPage: React.FC = () => {
    const {resources, waitlistCta} = useSiteContent();
    const {openWaitlist} = useWaitlist();

    return (
        <div className={styles.page}>
            <section className={styles.section}>
                <HeroSection
                    description={resources.howItWorksHero.description}
                    eyebrow={resources.howItWorksHero.eyebrow}
                    metrics={resources.howItWorksMetrics}
                    panelDescription={resources.howItWorksHero.panelDescription}
                    panelLabel={resources.howItWorksHero.panelLabel}
                    panelTitle={resources.howItWorksHero.panelTitle}
                    title={resources.howItWorksHero.title}
                />
            </section>

            {/* 系统架构总览 — 六步闭环 */}
            <section className={styles.section}>
                <SectionTitle
                    description={resources.howItWorksSections.architecture.description}
                    eyebrow={resources.howItWorksSections.architecture.eyebrow}
                    title={resources.howItWorksSections.architecture.title}
                />
                <div className="site-section"/>
                <CapabilityFlow steps={resources.howItWorksFlowSteps} feedbackLoop/>
            </section>

            {/* AI 决策机制 */}
            <section className={styles.section}>
                <SectionTitle
                    description={resources.howItWorksSections.aiDecision.description}
                    eyebrow={resources.howItWorksSections.aiDecision.eyebrow}
                    title={resources.howItWorksSections.aiDecision.title}
                />
                <div className={`${styles.storyStack} site-section`}>
                    {resources.howItWorksAiDecision.map((story, index) => (
                        <SplitShowcase block={story} key={story.title} reverse={index % 2 === 1}/>
                    ))}
                </div>
            </section>

            {/* 三层技术架构 */}
            <section className={styles.section}>
                <SectionTitle
                    description={resources.howItWorksSections.layers.description}
                    eyebrow={resources.howItWorksSections.layers.eyebrow}
                    title={resources.howItWorksSections.layers.title}
                />
                <div className="site-section"/>
                <FeatureGrid items={resources.howItWorksBlocks}/>
            </section>

            {/* CTA */}
            <section className={styles.section}>
                <article className={`site-card ${styles.ctaPanel}`}>
                    <div>
                        <span className="site-eyebrow">{resources.howItWorksCta.eyebrow}</span>
                        <h3>{resources.howItWorksCta.title}</h3>
                        <p>{resources.howItWorksCta.description}</p>
                    </div>
                    <div className={styles.ctaActions}>
                        <Button size="large" type="primary" onClick={openWaitlist}
                                style={{height: 48, paddingInline: 32, fontSize: 16}}>
                            {waitlistCta.label}
                        </Button>
                    </div>
                </article>
            </section>
        </div>
    );
};

export default SolutionsPage;
